import { dateTimeFromServer } from '../utils/format'
import { JSON } from '../utils/types'
import { PaymentMethod } from './PaymentMethod'

export default class BankTransfer extends PaymentMethod {
  // Ecuador
  readonly paymentCode: string
  readonly instructions: string[]
  readonly formattedExpirationDate: string
  // Chile, Peru, Colombia
  readonly redirectUrl: string

  constructor(data: JSON) {
    super(data)
    this.paymentCode = data.payment_code
    this.instructions = data.instructions ?? []
    this.formattedExpirationDate = dateTimeFromServer(this.expirationDate, true)!
    this.redirectUrl = data.redirect_url
  }
}
